function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3179 20H3.34107C1.49875 20 0 18.5982 0 16.875V6.28906C0 4.56589 1.49875 3.16406 3.34107 3.16406H11.3179C13.1602 3.16406 14.6589 4.56589 14.6589 6.28906V16.875C14.6589 18.5982 13.1602 20 11.3179 20ZM3.34107 4.72656C2.41999 4.72656 1.67053 5.42755 1.67053 6.28906V16.875C1.67053 17.7365 2.41999 18.4375 3.34107 18.4375H11.3179C12.2389 18.4375 12.9884 17.7365 12.9884 16.875V6.28906C12.9884 5.42755 12.2389 4.72656 11.3179 4.72656H3.34107ZM18 14.9219V3.125C18 1.40182 16.5013 0 14.6589 0H5.38747C4.92612 0 4.5522 0.349731 4.5522 0.78125C4.5522 1.21277 4.92612 1.5625 5.38747 1.5625H14.6589C15.58 1.5625 16.3295 2.26349 16.3295 3.125V14.9219C16.3295 15.3534 16.7034 15.7031 17.1647 15.7031C17.6261 15.7031 18 15.3534 18 14.9219Z",
  fill: "#5FCA77"
});

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.f15a5fcd.svg";
export { ForwardRef as ReactComponent };